import { useTranslation } from 'react-i18next';
import camelCase from 'lodash/camelCase';

import { PLATFORM_THEME_COLORS, Typography } from '@thinknet-gmbh/platform-common-ui';

import { PageTopbar } from 'src/components/employee/page-topbar';
import {
  InfoWrapper,
  InfoElement,
} from 'src/pages/employee/sub-pages/employee-details/employee-details.styles';

import { ElementContainer, EducationsWrapper, MainWrapper } from './educations-and-skills.styles';


const EducationsAndSkillsView = ({
  educationsAndSkills,
  onClickEdit,
}: {
  educationsAndSkills: any;
  onClickEdit: () => void;
}) => {
  const { t } = useTranslation(['employee', 'common']);
  const { skills = [], ...educations } = educationsAndSkills
    ? educationsAndSkills
    : { skills: [{}] };

  return (
    <MainWrapper>
      <PageTopbar
        pageTitle="Educations and skills"
        onClickEdit={onClickEdit}
        createdBy={educationsAndSkills.createdBy}
      />
      <InfoWrapper>
        <EducationsWrapper>
          <ElementContainer>
            <Typography weight="bold" fontColor={PLATFORM_THEME_COLORS.grayVariations.dark}>
              {t(`employee:educationsAndSkills.labels.schoolEducations`)}
            </Typography>
            <InfoElement>
              <Typography weight="bold">{`${t(
                `employee:educationsAndSkills.labels.schoolName`
              )}:`}</Typography>
              <Typography fontColor={PLATFORM_THEME_COLORS.primary.grey}>
                {educations.schoolName
                  ? t(
                      `employee:labels.schoolOptions.${camelCase(
                        educations.schoolName.toLowerCase()
                      )}`
                    )
                  : '-'}
              </Typography>
            </InfoElement>
            <InfoElement>
              <Typography weight="bold">{`${t('common:labels.description')}:`}</Typography>
              <Typography fontColor={PLATFORM_THEME_COLORS.primary.grey}>
                {educations?.schoolEducationDescription || '-'}
              </Typography>
            </InfoElement>
          </ElementContainer>

          <ElementContainer>
            <Typography weight="bold" fontColor={PLATFORM_THEME_COLORS.grayVariations.dark}>
              {t(`employee:educationsAndSkills.labels.universityEducations`)}
            </Typography>
            <InfoElement>
              <Typography weight="bold">{`${t(
                `employee:educationsAndSkills.labels.universityName`
              )}:`}</Typography>
              <Typography fontColor={PLATFORM_THEME_COLORS.primary.grey}>
                {educations?.universityName || '-'}
              </Typography>
            </InfoElement>
            <InfoElement>
              <Typography weight="bold">{`${t('common:labels.description')}:`}</Typography>
              <Typography fontColor={PLATFORM_THEME_COLORS.primary.grey}>
                {educations?.universityEducationDescription || '-'}
              </Typography>
            </InfoElement>
          </ElementContainer>

          <ElementContainer>
            <Typography weight="bold" fontColor={PLATFORM_THEME_COLORS.grayVariations.dark}>
              {t(`employee:educationsAndSkills.labels.furtherEducations`)}
            </Typography>
            <InfoElement>
              <Typography weight="bold">{`${t(
                `employee:educationsAndSkills.labels.furtherName`
              )}:`}</Typography>
              <Typography fontColor={PLATFORM_THEME_COLORS.primary.grey}>
                {educations?.furtherName || '-'}
              </Typography>
            </InfoElement>
            <InfoElement>
              <Typography weight="bold">{`${t('common:labels.description')}:`}</Typography>
              <Typography fontColor={PLATFORM_THEME_COLORS.primary.grey}>
                {educations?.furtherEducationDescription || '-'}
              </Typography>
            </InfoElement>
          </ElementContainer>

          <ElementContainer>
            <Typography weight="bold" fontColor={PLATFORM_THEME_COLORS.grayVariations.dark}>
              {t(`employee:educationsAndSkills.labels.driversLicenses`)}
            </Typography>
            <InfoElement>
              <Typography weight="bold">{`${t(
                `employee:educationsAndSkills.labels.driversLicenses`
              )}:`}</Typography>
              <Typography fontColor={PLATFORM_THEME_COLORS.primary.grey}>
                {educations.driverLicenses
                  ? t(`common:labels.${educations.driversLicenses ? 'yes' : 'no'}`)
                  : '-'}
              </Typography>
            </InfoElement>
            <InfoElement>
              <Typography weight="bold">{`${t('common:labels.description')}:`}</Typography>
              <Typography fontColor={PLATFORM_THEME_COLORS.primary.grey}>
                {educations?.driversLicensesDescription || '-'}
              </Typography>
            </InfoElement>
          </ElementContainer>

          <ElementContainer>
            <Typography weight="bold" fontColor={PLATFORM_THEME_COLORS.grayVariations.dark}>
              {t(`employee:educationsAndSkills.labels.trainingEducations`)}
            </Typography>
            <InfoElement>
              <Typography weight="bold">{`${t(
                `employee:educationsAndSkills.labels.highestTrainingDegree`
              )}:`}</Typography>
              <Typography fontColor={PLATFORM_THEME_COLORS.primary.grey}>
                {educations.highestTrainingDegree
                  ? t(
                    `employee:labels.highestTrainingOptions.${camelCase(
                      educations.highestTrainingDegree.toLowerCase()
                    )}`
                  )
                  : '-'}
              </Typography>
            </InfoElement>
            <InfoElement>
              <Typography weight="bold">{`${t(
                `employee:educationsAndSkills.labels.trainingName`
              )}:`}</Typography>
              <Typography fontColor={PLATFORM_THEME_COLORS.primary.grey}>
                {educations?.trainingName || '-'}
              </Typography>
            </InfoElement>
            <InfoElement>
              <Typography weight="bold">{`${t('common:labels.description')}:`}</Typography>
              <Typography fontColor={PLATFORM_THEME_COLORS.primary.grey}>
                {educations?.trainingDescription || '-'}
              </Typography>
            </InfoElement>
          </ElementContainer>
        </EducationsWrapper>

        <ElementContainer>
          <Typography weight="bold" fontColor={PLATFORM_THEME_COLORS.grayVariations.dark}>
            {t('employee:educationsAndSkills.labels.skills')}
          </Typography>
          {skills.map((item: any, index: any) => (
            <ElementContainer key={index}>
              <InfoElement>
                <Typography weight="bold">{`${t('employee:labels.skillsName')}:`}</Typography>
                <Typography fontColor={PLATFORM_THEME_COLORS.grayVariations.dark}>
                  {item?.name || '-'}
                </Typography>
              </InfoElement>
              <InfoElement>
                <Typography weight="bold">{`${t('common:labels.description')}:`}</Typography>
                <Typography fontColor={PLATFORM_THEME_COLORS.grayVariations.dark}>
                  {item?.description || '-'}
                </Typography>
              </InfoElement>
            </ElementContainer>
          ))}
        </ElementContainer>
      </InfoWrapper>
    </MainWrapper>
  );
};

export default EducationsAndSkillsView;
